import {
  Group,
  Text,
  UnstyledButton,
  Code,
  useMantineTheme
} from "@mantine/core";
import { IconSearch } from "@tabler/icons-react";
// import { modals } from "@mantine/modals";
import SpotlightForm from "./SpotlightForm";
import { useEffect, useRef } from "react";
// import classes from "./SpotlightControl.module.scss";
import { logger } from "utils/logger";
import { AppConstants } from "utils/constants";
import { connect } from "react-redux";
import { openModal } from "@mantine/modals";

const SpotlightControl = ({ globalSearch }) => {
  const theme = useMantineTheme();

  const openGlobalSearch = () => {
    logger.log("her");

    openModal({
      title: "",
      size: "100%",
      withCloseButton: false,
      classNames: { // ✅ v5: use classNames object instead of className string
        modal: `spotlightModal ${
          globalSearch?.results && globalSearch?.results.length > 0
            ? "open"
            : Array.isArray(globalSearch?.results) &&
              globalSearch?.results.length === 0
            ? "empty"
            : ""
        }`,
      },
      closeOnEscape: false,
      children: (
        <>
          <SpotlightForm />
        </>
      ),
    });
  };

  useEffect(() => {
    const handleKeyPress = (event) => {
      if (event.key === "k" && (event.metaKey || event.ctrlKey)) {
        event.preventDefault();
        openGlobalSearch();
      }
    };

    window.addEventListener("keydown", handleKeyPress);

    return () => {
      window.removeEventListener("keydown", handleKeyPress);
    };
  }, []);

  const modalElementRef = useRef(null);

  useEffect(() => {
    const updateModalClasses = () => {
      // ✅ v5: modal wrapper class changed from .spotlightModal to [data-modal]
      // Target via the classNames.modal approach or query the new selector
      const modalElement =
        modalElementRef.current ||
        document.querySelector(".spotlightModal"); // keep if using custom classNames

      if (!modalElement) {
        requestAnimationFrame(updateModalClasses);
        return;
      }

      if (!modalElementRef.current) {
        modalElementRef.current = modalElement;
      }

      const results = globalSearch?.results;
      const hasResults = results?.length > 0;
      const isEmpty = Array.isArray(results) && results.length === 0;

      modalElement.classList.toggle("open", hasResults);
      modalElement.classList.toggle("empty", isEmpty);
    };

    const rafId = requestAnimationFrame(updateModalClasses);

    return () => {
      cancelAnimationFrame(rafId);
    };
  }, [globalSearch?.results]);

  return (
    <Group position="center"> {/* ✅ v5: position="center" still valid */}

<UnstyledButton onClick={openGlobalSearch}>
                <Group
                    sx={(theme) => ({
                        // subscribe to color scheme changes
                        // height: '34px',
                        borderRadius: `${theme.radius.md}px`,
                        color: theme.colors.gray[6],
                        backgroundColor: theme.colorScheme === 'dark' ? theme.colors.dark[5] : theme.white,
                        border: `1px solid ${theme.colors.gray[4]}`,
                        borderColor: theme.colorScheme === 'dark' ? theme.colors.dark[6] : theme.colors.gray[4],
                        padding: `${theme.spacing.sm / 2}px ${theme.spacing.sm / 2}px`,
                    })}
                    spacing='xs'>
                    <IconSearch size={20} color='grey' />
                    <Text sx={{ width: 200 }} size='sm'>
                        Quick Style Lookup
                    </Text>
                    <Code
                        sx={(theme) => ({
                            // subscribe to color scheme changes
                            border: theme.colorScheme === 'dark' ? `1px solid ${theme.colors.dark[3]}` : `1px solid ${theme.colors.gray[2]}`,
                        })}>
                        ⌘ + K
                    </Code>
                    {/* <Text size="xs" color="gray">bob@handsome.inc</Text> */}
                </Group>
            </UnstyledButton>

      {/* <UnstyledButton
        onClick={openGlobalSearch}
        w={300}
        className={classes.container}
      >
        <Group className={`${classes.buttonInner} ${classes.content}`} spacing="xs">
          <IconSearch size={AppConstants.ICON_SIZE} color="grey" />
          <Text style={{ flexGrow: 1 }} size="sm">
            Quick Style Lookup
          </Text>
          <Code className={classes.code}>
            ⌘ + K
          </Code>
        </Group>
      </UnstyledButton> */}
    </Group>
  );
};

const mapStateToProps = (state) => ({
  globalSearch: state.appReducer.globalSearch,
});

export default connect(mapStateToProps)(SpotlightControl);